import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
// import ClienteService from '@/features/tab-cliente/service';
import GarantiaService from '@/features/tab-garantia/service';
import ReportService from '@/features/reports/service';
import DatosEconomicosService from '@/features/tab-datos-economicos/service';

import {
  processOperationResponse,
  processDatesAssigmentsResponse,
  formatOperation,
  formatDatesAssigments } from './utils';

export const OPERATION_URL = `${API_CONFIG.API}/node/operation`;
export const DATESASSIGMENTS_URL = `${API_CONFIG.API}/node/date_assignement`;
export const REPORT_URL = `${API_CONFIG.API}/node/prereport`;
export const OPERATION_INCLUDES = 'dates_assigments,state,volume,prereport,notario_operacion,report,' +
  'expenses,product,clients,pledge,documents,documents_needed,letras_operation';
export const OPERATION_FILTERS = 'fields[taxonomy_term--status]=name';
export default {
  getOperationData(uuid) {
    return base.http().get(`${OPERATION_URL}/${uuid}?include=${OPERATION_INCLUDES}&${OPERATION_FILTERS}`)
      .then(response => processOperationResponse(response));
  },
  getDatesAssigmentsData(uuid) {
    return base.http().get(`${DATESASSIGMENTS_URL}/${uuid}?include=colaborador`)
      .then(response => processDatesAssigmentsResponse(response));
  },
  createOperation(model) {
    const { operationEntry, title } = model;
    const datesToSave = { operationEntry, title };
    const preReportToSave = { title: `${title}-pr` };
    const reportToSave = { title: `${title}-r` };
    const datesAssigments = {};
    const preReport = {};
    const report = {};
    return base.http().post(`${DATESASSIGMENTS_URL}`, formatDatesAssigments(datesToSave))
      .then(res => Object.assign(datesAssigments, processDatesAssigmentsResponse(res)))
      .then(() => ReportService.saveReport(reportToSave))
      .then(res => Object.assign(report, res))
      .then(() => ReportService.savePreReport(preReportToSave))
      .then(res => Object.assign(preReport, res))
      .then(() => Object.assign({}, model, {
        datesAssigments: datesAssigments.id,
        preReport: preReport.id,
        report: report.id }))
      .then(opToSave => base.http().post(`${OPERATION_URL}`, formatOperation(opToSave)))
      .then(res => Object.assign({ operation: processOperationResponse(res), datesAssigments, preReport, report }));
  },
  updateOperation(model) {
    const { id } = model;
    return base.http().patch(`${OPERATION_URL}/${id}?include=state`, formatOperation(model))
      .then(response => processOperationResponse(response));
  },
  updateOperationClients(model) {
    const { id } = model;
    return base.http().patch(`${OPERATION_URL}/${id}/relationships/clients`, formatOperation(model))
      .then(response => processOperationResponse(response));
  },
  updateDatesAssigments(model) {
    const { id } = model;
    return base.http().patch(`${DATESASSIGMENTS_URL}/${id}`, formatDatesAssigments(model))
      .then(response => processDatesAssigmentsResponse(response));
  },
  removeOperation(uid) {
    return base.http().delete(`${OPERATION_URL}/${uid}`);
  },
  searchOperationByName(title) {
    return base.http().get(`${OPERATION_URL}/?filter[title][value]=${title}`)
      .then(response => processOperationResponse(response));
  },
  exitsOperationName(payload) {
    return this.searchOperationByName(payload)
      .then((lista) => {
        let exists = false;
        if (lista.length === 0) {
          return { exists };
        }
        lista.forEach((item) => {
          exists = exists || item.attributes.title === payload;
        });
        return { exists };
      });
  },
  getGarantiasOperation(operation) {
    return GarantiaService.getGarantiasOperation(operation);
  },
  getImportesOperation(operation) {
    return DatosEconomicosService.initImportesDatosEconomicos(operation);
  },
  getGastosOperation(operation) {
    return DatosEconomicosService.initGastosDatosEconomicos(operation);
  },
};



// WEBPACK FOOTER //
// ./src/features/operation/service.js